import _ from 'lodash';
import { axiosInstance } from '../helpers';
import { userService } from './user.service';

const getPaymentsReport = (query) => {
    return axiosInstance
        .get(`/payments/report`, { params: query })
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => {
            handleResponse(error.response);
        });
};

const createResponseError = (status, message) => {
    const responseError = new Error(message || `Request failed with status ${status}`);
    responseError.status = status;
    responseError.error = message;
    return responseError;
};

const handleResponse = response => {
    if (!response) throw createResponseError(500);
    const data = response.data;
    if (!_.includes([200, 201, 204], response.status)) {
        if (response.status === 401 && !response.config.url.includes('/users/login')) {
            // auto logout if 401 response returned from api
            userService.logout();
            window.location.reload(true);
        }

        const error = (data && data.message) || response.statusText;

        throw createResponseError(response.status, error);
    }

    return data;
};

export const paymentService = {
    getPaymentsReport,
};
